module.exports = __webpack_public_path__ + "static/media/favicon.2d30c62a.ico";